import React, { useState } from 'react';
import { FiFolder, FiFile, FiUpload } from 'react-icons/fi';
import useLocalState from '../hooks/useLocalState';

const initialFiles = [];
const initialFolders = ['General Docs', 'Project Assets', 'Invoices', 'Suppliers'];

export default function Documents() {
  const [files, setFiles] = useLocalState('docs_files', initialFiles);
  const [folders] = useLocalState('docs_folders', initialFolders);

  return (
    <div className="flex h-full font-sans overflow-hidden bg-gray-50">
      <div className="w-64 bg-white border-r border-gray-200 p-4 flex flex-col">
        <h3 className="font-bold text-gray-800 mb-4 flex items-center"><FiFolder className="mr-2 text-yellow-500" /> Folders</h3>
        <ul className="space-y-2 text-sm text-gray-700 flex-1 overflow-y-auto">
          {folders.map(f => (
            <li key={f} className="flex items-center cursor-pointer hover:text-blue-600"><FiFolder className="mr-2" /> {f}</li>
          ))}
        </ul>
      </div>
      <div className="flex-1 p-6 flex flex-col">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-xl font-bold text-gray-800">Documents</h2>
          <button className="bg-[#0000a0] text-white px-4 py-2 rounded shadow flex items-center"><FiUpload className="mr-2" /> Upload File</button>
        </div>
        <div className="flex-1 bg-white border border-gray-200 rounded shadow-sm overflow-x-auto">
          <table className="min-w-full text-sm">
            <thead className="bg-gray-50 border-b border-gray-200">
              <tr>
                <th className="p-3 text-left font-medium text-gray-600">File Name</th>
                <th className="p-3 text-left font-medium text-gray-600">Size</th>
                <th className="p-3 text-left font-medium text-gray-600">Date</th>
                <th className="p-3 text-left font-medium text-gray-600">Uploaded By</th>
              </tr>
            </thead>
            <tbody>
              {files.length === 0 ? (
                <tr><td colSpan="4" className="p-8 text-center text-gray-400 italic">No documents found.</td></tr>
              ) : (
                files.map(f => (
                  <tr key={f.id} className="border-b border-gray-100 hover:bg-gray-50">
                    <td className="p-3 flex items-center"><FiFile className="mr-2 text-gray-400" /> {f.name}</td>
                    <td className="p-3 text-gray-500">{f.size}</td>
                    <td className="p-3 text-gray-500">{f.date}</td>
                    <td className="p-3 text-gray-500">{f.by}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}